"use client";

import { useCallback } from "react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export type CcTrafficSelectOption = {
  value: string;
  label: string;
};

type CcTrafficSelectProps = {
  id: string;
  value: string;
  onValueChange: (value: string) => void;
  options: readonly CcTrafficSelectOption[];
  "aria-labelledby"?: string;
};

export function CcTrafficSelect({
  id,
  value,
  onValueChange,
  options,
  "aria-labelledby": ariaLabelledBy,
}: CcTrafficSelectProps) {
  const handleValueChange = useCallback(
    (next: string) => {
      onValueChange(next);
      queueMicrotask(() => {
        document.getElementById(id)?.blur();
      });
    },
    [id, onValueChange],
  );

  return (
    <Select value={value} onValueChange={handleValueChange}>
      <SelectTrigger
        id={id}
        aria-labelledby={ariaLabelledBy}
        className="cc-traffic__input cc-traffic__select cc-traffic__shadcn-select"
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent
        className="cc-traffic__shadcn-select-content"
        position="popper"
        align="start"
        sideOffset={4}
      >
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
